import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import { safeGetId } from './utils';
import { isEqual, get } from 'lodash';
export var defaultFilter = function defaultFilter(items, inputValue) {
  return _filterInstanceProperty(items).call(items, function (item) {
    var _context;

    return _includesInstanceProperty(_context = get(item, 'label', '').toString().toLowerCase()).call(_context, inputValue.toLowerCase());
  });
};
export var defaultFreeformValueNormalizer = function defaultFreeformValueNormalizer(value) {
  return {
    value: value,
    label: value
  };
};
export var defaultItemToString = function defaultItemToString(item) {
  return get(item, 'label', '');
};
export var defaultStateReducer = function defaultStateReducer(_, changes) {
  return changes;
};
export var defaultSelectedItemChanged = function defaultSelectedItemChanged(prev, current) {
  return !isEqual(prev, current);
};
export var defaultPluckId = function defaultPluckId(item) {
  return safeGetId(item);
};
export var defaultMultiFilter = function defaultMultiFilter(items, _, selectedItems) {
  return _filterInstanceProperty(items).call(items, function (item) {
    return !_findInstanceProperty(selectedItems).call(selectedItems, function (selectedItem) {
      return defaultPluckId(selectedItem) === defaultPluckId(item);
    });
  });
};
export var defaultInitialSelectedItems = [];
export var defaultMultiItemToString = function defaultMultiItemToString(itemOrItems) {
  return _Array$isArray(itemOrItems) ? _mapInstanceProperty(itemOrItems).call(itemOrItems, function (item) {
    return get(item, 'label', '');
  }).join(', ') : get(itemOrItems, 'label', '');
};